<template>
  <router-view class="font-mono text-sm"/>
</template>

